import { LOGO } from "@/lib/brand";

export const Logo = ({ variant = "light", size = "md", showTagline = false, className = "" }) => {
  const dims = size === "sm" ? "h-7" : size === "lg" ? "h-11" : "h-9";
  const textSize = size === "sm" ? "text-lg" : size === "lg" ? "text-3xl" : "text-2xl";
  const wordColor = variant === "dark" ? "text-[#F4FFF9]" : "text-[#0D3B2D]";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img src={LOGO.icon} alt="ECOREXS" className={`${dims} w-auto object-contain`} />
      <div className="flex flex-col leading-none">
        <span className={`font-heading font-bold tracking-tight ${textSize} ${wordColor}`}>
          ECOREX<span className="text-[#10B981]">S</span>
        </span>
        {showTagline && (
          <span className="font-mono text-[9px] tracking-[0.2em] text-[#4A635A] mt-1 uppercase">
            Managed Digital Infrastructure
          </span>
        )}
      </div>
    </div>
  );
};

export default Logo;
